/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable dot-location */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Col,
  Container,
  Row,
  Form,
  CardBody,
  Card,
  Label,
  Input,
  Button,
  TabContent,
  TabPane,
  Nav,
  NavLink,
  NavItem,
  CardHeader,
  Media,
} from "reactstrap";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import BreadCrumb from "Components/Common/BreadCrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import check from "../../../assets/images/nick.png";
import Nic from "../../../assets/images/nic.png";
import fbr from "../../../assets/images/fbr.png";
import SimpleBar from "simplebar-react";
import classnames from "classnames";
import { useSelector, useDispatch } from "react-redux";
import {
  FirebaseAuthBackend,
  getFirebaseBackend,
} from "helpers/firebase_helper";
import Loader from "Components/Common/Loader";
import {
  getBank,
  updateBankInformation,
  updateBussinessInformation,
} from "live-slices/thunk";
import { createSelector } from "reselect";
import AddressFormBox from "Components/Common/AddressFormBox";
import { useNavigate } from "react-router-dom";
import withRouter from "Components/Common/withRouter";
import { toast } from "react-toastify";
import { updateUserState } from "live-slices/user/reducer";
import ImageViewer from "Components/Common/ImageViewer";
import MediaUploader from "Components/Common/MediaUploader";

// Register the plugins

const BankInformation = (props: any) => {
  document.title = "Bank Information | BuyPass";

  const [sellerType, setSellerType] = useState("personal");
  const [faqsType, setfaqsType] = useState("faqsOne");
  const [address, setaddress] = useState<any>();
  const [accountType, setAccountType] = useState("");
  const [activeVerticalTab, setactiveVerticalTab] = useState<number>(7);
  const [passedverticalSteps, setPassedverticalSteps] = useState<any>([1]);
  const [selectFrontCnicImageLoading, setSelectFrontCnicImageLoading] =
    useState<any>(false);
  const [selectBackCnicImageLoading, setSelectBackCnicImageLoading] =
    useState<any>(false);
  const [selectImageBankLoading, setSelectImageBankLoading] =
    useState<any>(false);
  const [selectImageBusinessLoading, setSelectImageBusinessLoading] =
    useState<any>(false);

  const firebaesHelper: FirebaseAuthBackend | null = getFirebaseBackend();
  const [selectedFrontCnicImage, setSelectedFrontCnicImage] = useState<any>();
  const [selectedBackCnicImage, setSelectedBackCnicImage] = useState<any>();
  const [selectedBusinessImage, setSelectedBusinessImage] = useState<any>();
  const [selectedImageBank, setSelectedImageBank] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [isViewerOpen, setViewerOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const [isToggled, setIsToggled] = useState(false);
  const closeViewer = () => {
    setViewerOpen(false);
  };

  const openViewer = (imageUrl: any) => {
    setCurrentImage(imageUrl);
    setViewerOpen(true);
  };

  const handleSellerTypeChange = (e: any) => {
    const value = e.target.value;
    setSellerType(value);

    // Update accountType based on sellerType
    if (value === "personal") {
      setAccountType("personalAccountType");
    } else {
      setAccountType("businessAccountType");
    }
  };

  const handleFaqsTypeChange = (e: any) => {
    const value = e.target.value;
    setfaqsType(value);

    // Update accountType based on sellerType
    if (value === "personal") {
      setAccountType("personalAccountType");
    } else {
      setAccountType("businessAccountType");
    }
  };

  const handleFrontCnicImageChange = async (event: any) => {
    setSelectFrontCnicImageLoading(true);
    try {
      const file = event.target.files[0];
      if (file) {
        const res = await firebaesHelper?.uploadImage(file, "product/");
        const fileObj = getFileObj(file, res);
        setSelectedFrontCnicImage(fileObj);
        formik.setFieldValue("cnicFrontImage", fileObj.url);
      }
      setSelectedFrontCnicImage(false);
    } catch (e) {
      setSelectFrontCnicImageLoading(false);
      console.log(e);
    }
  };

  const handleBackCnicImageChange = async (event: any) => {
    setSelectBackCnicImageLoading(true);
    try {
      const file = event.target.files[0];
      if (file) {
        const res = await firebaesHelper?.uploadImage(file, "product/");
        const fileObj = getFileObj(file, res);
        setSelectedBackCnicImage(fileObj);
        formik.setFieldValue("cnicBackImage", fileObj.url);
      }
      setSelectBackCnicImageLoading(false);
    } catch (e) {
      setSelectBackCnicImageLoading(false);
      console.log(e);
    }
  };

  const handleBussinessImageChange = async (event: any) => {
    setSelectImageBusinessLoading(true);
    try {
      const file = event.target.files[0];
      const res = await firebaesHelper?.uploadImage(file, "product/");
      const fileObj = getFileObj(file, res);
      setSelectedBusinessImage(fileObj);
      formik.setFieldValue("businessDocuments", fileObj.url);
      setSelectedImageBank(getFileObj(file, res));
      setSelectImageBusinessLoading(false);
    } catch (e) {
      setSelectImageBusinessLoading(false);
      console.log(e);
    }
  };

  const handleBankImageChange = async (event: any) => {
    setSelectImageBankLoading(true);
    try {
      const file = event.target.files[0];
      const res = await firebaesHelper?.uploadImage(file, "product/");
      const fileObj = getFileObj(file, res);
      setSelectedImageBank(fileObj);
      formik.setFieldValue("bankDocuments", fileObj.url);

      setSelectedImageBank(getFileObj(file, res));
      setSelectImageBankLoading(false);
    } catch (e) {
      setSelectImageBankLoading(false);
      console.log(e);
    }
  };

  const handleDeleteFrontCnicImage = () => {
    formik.setFieldValue("cnicFrontImage", "");
    formik.setFieldValue("cnicFrontImageMetadata", {});
    setSelectedFrontCnicImage(null);
  };

  const handleDeleteBackCnicImage = () => {
    formik.setFieldValue("cnicBackImage", "");
    formik.setFieldValue("cnicBackImageMetadata", {});
    setSelectedBackCnicImage(null);
  };

  const handleDeleteBusinessImage = () => {
    formik.setFieldValue("businessDocuments", "");
    formik.setFieldValue("businessDocumentsMetadata", {});
    setSelectedBusinessImage(null);
  };

  const handleDeleteImageBank = () => {
    formik.setFieldValue("bankDocuments", "");
    formik.setFieldValue("bankDocumentsMetadata", {});
    setSelectedImageBank(null);
  };

  const dispatch = useDispatch<any>();

  function toggleVerticalTab(tab: any) {
    if (activeVerticalTab !== tab) {
      var modifiedSteps = [...passedverticalSteps, tab];

      if (tab >= 7 && tab <= 11) {
        setactiveVerticalTab(tab);
        setPassedverticalSteps(modifiedSteps);
      }
    }
  }

  const handleToggle = () => {
    formik.setFieldValue(
      "isBusinessAddressSame",
      !formik.values.isBusinessAddressSame
    );
    console.log("data", formik.values.isBusinessAddressSame);
  };

  const selectSeller = createSelector(
    (state: any) => state.Business,
    (business) => business?.business
  );

  const selectUser = createSelector(
    (state: any) => state.User,
    (user) => user?.user
  );

  const user = useSelector(selectUser);
  const seller = useSelector(selectSeller);

  const [banks, setBanks] = useState([]);
  const fetchBankDetails = async () => {
    setLoading(true);
    try {
      const response = await dispatch(getBank()).unwrap();
      setBanks(response);
    } catch (error) {
      console.error("Error fetching banks:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBankDetails();
  }, [dispatch]);

  const onMediaUpdate = (key: string, value: Media | any) => {
    console.log(key, value);
    if (key === "businessDocuments") {
      setSelectedBusinessImage(value);
      let url: string | undefined;
      let media: Media | undefined;
      if (Array.isArray(value)) {
        url = value[0]?.url;
      } else {
        url = value?.url;
      }
      if (url) {
        formik.setFieldValue("idBankDetails.bankDocuments[0].url", url);
      }
    } else if (key === "cnicBackImage") {
      setSelectedBackCnicImage(value);
      let url: string | undefined;
      let media: Media | undefined;
      if (Array.isArray(value)) {
        url = value[0]?.url;
        media = value[0];
      } else {
        url = value?.url;
        media = value;
      }
      if (url) {
        formik.setFieldValue("cnicBackImage.url", url);
      }
    }
  };

  useEffect(() => {
    if (!seller) return;

    formik.setFieldValue("accountType", seller?.accountType || "");
    formik.setFieldValue(
      "accountName",
      seller?.idBankDetails?.accountName || ""
    );
    formik.setFieldValue(
      "accountNumber",
      seller?.idBankDetails?.accountNumber || ""
    );
    formik.setFieldValue("Iban", seller?.idBankDetails?.Iban || "");
    formik.setFieldValue("bank", seller?.idBankDetails?.bank || "");
    formik.setFieldValue("bankCode", seller?.idBankDetails?.bankCode || "");
    formik.setFieldValue("bankBranch", seller?.idBankDetails?.bankBranch || "");
    formik.setFieldValue(
      "isBusinessAddressSame",
      seller?.idBankDetails?.isBusinessAddressSame ?? false
    );
    if (
      seller &&
      seller.idBankDetails &&
      Array.isArray(seller.idBankDetails.bankDocuments)
    ) {
      formik.setFieldValue(
        "bankDocuments",
        seller.idBankDetails.bankDocuments[0]?.url || ""
      );
    } else {
      formik.setFieldValue("bankDocuments", "");
    }
    if (
      seller &&
      seller.idBankDetails &&
      Array.isArray(seller.idBankDetails.businessDocuments)
    ) {
      formik.setFieldValue(
        "businessDocuments",
        seller.idBankDetails.businessDocuments[0]?.url || ""
      );
    } else {
      formik.setFieldValue("businessDocuments", "");
    }
    formik.setFieldValue("cnicNumber", seller?.nationality?.cnicNumber || "");
    formik.setFieldValue(
      "businessRegistrationNumber",
      seller?.idBankDetails?.businessRegistrationNumber || ""
    );
    formik.setFieldValue("sellerType", seller?.accountType || "");
    formik.setFieldValue("companyLegalName", seller?.address?.state || "");
    formik.setFieldValue(
      "cnicBackImage",
      seller?.nationality?.cnicBackImage.url || ""
    );
    formik.setFieldValue(
      "cnicFrontImage",
      seller?.nationality?.cnicFrontImage.url || ""
    );
    // formik.setFieldValue("cnicFrontImage", seller?.nationality?.cnicNumber || "");
    formik.setFieldValue("cnicName", seller?.nationality?.cnicName || "");
    if (seller.idBankDetails && seller.idBankDetails.businessAddress) {
      setaddress(seller.idBankDetails.businessAddress);
    }
  }, [seller]);

  const validationSchema = Yup.object({
    // companyLegalName: Yup.string()
    //   .required('Name on ID is required'),
    // businessRegistrationNumber: Yup.string()
    //   .required('ID Number is required'),

    accountName: Yup.string().required("Account Name is required"),
    accountNumber: Yup.string().required("Account Number is required"),
    Iban: Yup.string().required("IBAN is required"),

    bankBranch: Yup.string().required("Bank Branch is required"),
    bankCode: Yup.string().required("Bank Code is required"),
    cnicName: Yup.string().required("Cnic name is required"),
    cnicNumber: Yup.string().required("Cnic number is required"),
    // cnicFrontImage: Yup.string()
    // .required('Cnic Front Image is required'),
    // cnicBackImage: Yup.string()
    // .required('Cnic Back Image is required'),
  });

  const validationSchemaBusiness = Yup.object({
    companyLegalName: Yup.string().required("Company Legal Name is required"),
    businessRegistrationNumber: Yup.string().required(
      "Business Registration Number is required"
    ),
  });

  const formik = useFormik({
    initialValues: {
      accountName: "",
      accountNumber: "",
      Iban: "",
      bank: "",
      bankCode: "",
      bankBranch: "",
      companyLegalName: "",
      businessRegistrationNumber: "",
      sellerType: "",
      businessDocuments: null,
      cnicNumber: "",
      bankDocuments: null,
      accountType: "",
      cnicFrontImage: null,
      cnicBackImage: null,
      cnicName: "",
      streetAddress: "",
      state: "",
      city: "",
      zone: "",
      isBusinessAddressSame: false,
    },
    validationSchema:
      sellerType === "business" ? validationSchemaBusiness : validationSchema,

    onSubmit: (values) => {
      console.log("Form Submitted", values);
      if (sellerType === "business") {
        if (!values.businessDocuments) {
          toast.error("Business Documents Image is required");
          return;
        }
      } else {
        if (!values.cnicFrontImage) {
          toast.error("Cnic Front Image is required");
          return;
        }
        if (!values.cnicBackImage) {
          toast.error("Cnic Back Image is required");
          return;
        }
        if (!values.bankDocuments) {
          toast.error("Bank Documents Image is required");
          return;
        }
      }

      const updatedSeller: any = {
        _id: seller._id,
        idBankDetails: {
          businessAddress: address,
          swift: seller.swift || "Abc",
          isBusinessAddressSame: values.isBusinessAddressSame,

          businessDocuments: [
            {
              url: values.businessDocuments!,
              metaData: {
                height: 0,
                width: 0,
                fileType: "",
                fileFormat: "",
                name: "",
                duration: 0,
              },
            },
          ],
          companyLegalName: values.companyLegalName || "",
          businessRegistrationNumber: values.businessRegistrationNumber || "",
          bankDocuments: [
            {
              url: values.bankDocuments || "",
              metaData: {
                height: 0,
                width: 0,
                fileType: "",
                fileFormat: "",
                name: "",
                duration: 0,
              },
            },
          ],
          accountName: values.accountName || "",
          accountNumber: values.accountNumber || "",
          Iban: values.Iban || "",
          bank: values.bank || "",
          bankCode: values.bankCode || "",
          bankBranch: values.bankBranch || "",
        },
        nationality: {
          cnicFrontImage: {
            url: values.cnicFrontImage || "",
            metaData: {
              height: 0,
              width: 0,
              fileType: "",
              fileFormat: "",
              name: "",
              duration: 0,
            },
          },
          cnicBackImage: {
            url: values.cnicBackImage || "",
            metaData: {
              height: 0,
              width: 0,
              fileType: "",
              fileFormat: "",
              name: "",
              duration: 0,
            },
          },
          cnicNumber: values.cnicNumber || "",
          cnicName: values.cnicName || "",
        },
      };
      dispatch(
        updateBankInformation({ formData: updatedSeller, navigate })
      ).then(() => {
        dispatch(
          updateUserState({
            storeStatus: {
              ...user.storeStatus,
              isIdBankDetails: true,
            },
          })
        );
        // navigate('/on-boarding' ,{ state: { activeTab: 3 } });
      });
    },
  });
  const navigate = useNavigate();

  const handleFieldChange = (key: string, e: any) => {
    formik.setFieldValue(key, e.target.value);
  };

  const getFileObj = (file: any, url: any) => {
    return {
      url,
      metadata: {
        height: file.height || 0,
        width: file.width || 0,
        fileType: file.type || "string",
        fileFormat: file.name.split(".").pop() || "string",
        name: file.name || "string",
        duration: file.duration || 0,
      },
    };
  };

  const onBusinessAddressChange = (address: any) => {
    setaddress(address);
  };

  return (
    seller && (
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Verify Bank Information to get payment!"
            pageTitle="Ecommerce"
            pageTitleRoute="/on-boarding"
          />
          <div className="d-flex align-items-center mb-2">
            <div className="flex-shrink-0 me-1">
              <i className="ri-shield-keyhole-line fs-18 align-middle text-success me-1"></i>
            </div>
            <div className="flex-grow-1">
              <h5 className="fs-14 mb-0 fw-500 text-success">
                Your account information is secure.
              </h5>
            </div>
          </div>
          <Row>
            <Col xl={9}>
              <Form onSubmit={formik.handleSubmit}>
                <Card>
                  <CardBody>
                    <h5 className="fw-bolder mb-3">*Seller Type</h5>
                    <div className="mt-4 mt-lg-0">
                      <div className="form-check form-check-inline">
                        <Input
                          className="form-check-input"
                          type="radio"
                          name="sellerType"
                          id="personal"
                          value="personal"
                          onChange={handleSellerTypeChange}
                          checked={sellerType === "personal"}
                        />
                        <Label className="form-check-label" htmlFor="personal">
                          Personal
                        </Label>
                      </div>
                      <div className="form-check form-check-inline">
                        <Input
                          className="form-check-input"
                          type="radio"
                          name="sellerType"
                          id="business"
                          value="business"
                          onChange={handleSellerTypeChange}
                          checked={sellerType === "business"}
                        />
                        <Label className="form-check-label" htmlFor="business">
                          Business
                        </Label>
                      </div>
                    </div>
                  </CardBody>
                </Card>

                {sellerType === "business" && (
                  <Card>
                    <CardBody>
                      <h3 className="fw-bold mb-2">Upload Business Document</h3>
                      <div className="my-3">
                        <h6 className="fw-bold">
                          <span className="text-danger">*</span> Business
                          Document Upload{" "}
                          <span>
                            <i className="ri-information-line ms-2 fs-5 fw-normal"></i>
                          </span>
                        </h6>
                      </div>

                      <Row
                        style={{ background: "#f8f9fd" }}
                        className="rounded-3 p-3 mx-1"
                      >
                        <Col sm={12} md={4} lg={4} xxl={4}>
                          <h5 className="fw-bolder">
                            Business Document Upload
                          </h5>
                          <MediaUploader
                            onMediaUpdate={(value: any) =>
                              onMediaUpdate("businessDocuments", value)
                            }
                            isMultiple={false}
                            initialMedia={seller.idBankDetails.bankDocuments}
                          />
                        </Col>
                        <Col sm={12} md={4} lg={4} xxl={4}>
                          <h5 className="fw-bold text-success">
                            You may follow these sample type(s). Full list
                            below.
                          </h5>
                          <figure className="flex justify-center items-center">
                            <img
                              src={fbr}
                              alt="Email Communication"
                              className="w-20 h-20 object-contain"
                            />
                          </figure>
                        </Col>

                        <Col sm={12} md={4} lg={4} xxl={4}>
                          <h6 className="text-black-50">
                            Ensure clear photo of legal name, photo, and ID
                            Number (for Individual sellers); business name &
                            business registration ID (for Corporate sellers)
                            <p className="text-black-50 mt-4">
                              Size between 330x330 and 5000x5000 px, and image
                              size below 10M.Please do upload the photo with
                              similar with the example.
                            </p>
                          </h6>
                        </Col>
                      </Row>

                      <h3 className="fw-bold my-2">
                        Verify Business Information
                      </h3>
                      <Col xxl={6} md={12} sm={12} lg={12} className="mt-3">
                        <Label htmlFor="addressDetails" className="form-label">
                          <span className="text-danger me-1"> *</span>Company
                          Legal Name
                          <span>
                            <i className="ri-information-line ms-2 fs-5 fw-normal"></i>
                          </span>
                        </Label>
                        <Input
                          type="text"
                          name="companyLegalName"
                          className={`form-control ${
                            formik.touched.companyLegalName &&
                            formik.errors.companyLegalName
                              ? "is-invalid"
                              : ""
                          }`}
                          id="companyLegalName"
                          placeholder="Company Legal Name"
                          onChange={(e) => {
                            formik.handleChange(e);
                            handleFieldChange("companyLegalName", e);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.companyLegalName}
                        />
                        {formik.touched.companyLegalName &&
                          formik.errors.companyLegalName && (
                            <div className="invalid-feedback">
                              {formik.errors.companyLegalName}
                            </div>
                          )}
                      </Col>
                      <Col xxl={6} md={12} sm={12} lg={12} className="mt-3">
                        <Label htmlFor="addressDetails" className="form-label">
                          <span className="text-danger me-1"> *</span>Business
                          Registration Number
                          <span>
                            <i className="ri-information-line ms-2 fs-5 fw-normal"></i>
                          </span>
                        </Label>
                        <Input
                          type="text"
                          name="businessRegistrationNumber"
                          className={`form-control ${
                            formik.touched.businessRegistrationNumber &&
                            formik.errors.businessRegistrationNumber
                              ? "is-invalid"
                              : ""
                          }`}
                          id="businessRegistrationNumber"
                          placeholder="Business Registration Number"
                          onChange={(e) => {
                            formik.handleChange(e);
                            handleFieldChange("businessRegistrationNumber", e);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.businessRegistrationNumber}
                        />
                        {formik.touched.accountNumber &&
                          formik.errors.businessRegistrationNumber && (
                            <div className="invalid-feedback">
                              {formik.errors.businessRegistrationNumber}
                            </div>
                          )}
                      </Col>
                    </CardBody>
                  </Card>
                )}

                {sellerType === "personal" && (
                  <Card>
                    <CardBody>
                      <h3 className="fw-bold mb-2">Upload ID Document</h3>
                      <div className="mt-lg-0">
                        <h6>*ID Type</h6>
                        <div className="form-check form-check-inline my-2">
                          <Input
                            className="form-check-input"
                            type="radio"
                            name="inlineRadioOptions1"
                            id="inlineRadio1"
                            value="option1"
                            checked // This ensures it's always selected
                          />
                          <Label
                            className="form-check-label"
                            htmlFor="inlineRadio1"
                          >
                            Personal ID
                          </Label>
                        </div>
                      </div>

                      <div className="my-3">
                        <h6 className="fw-bold">
                          <span className="text-danger">*</span> ID Document
                          Upload
                        </h6>
                      </div>

                      <Row
                        style={{ background: "#f8f9fd" }}
                        className="rounded-3 p-3 mx-1"
                      >
                        <Col sm={12} md={4} lg={4} xxl={4}>
                          <h5 className="fw-bolder">Upload NIC Front Image</h5>
                          <div
                            className={`dropzone dz-clickable ${
                              formik.values.cnicFrontImage ? "d-none" : ""
                            }`}
                          >
                            {!formik.values.cnicFrontImage && (
                              <>
                                <Label
                                  htmlFor="front-cnic"
                                  className="mb-0 d-flex"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="right"
                                  title="Select Image"
                                >
                                  <div className="dz-message needsclick">
                                    <div className="mb-3 mt-5">
                                      <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                                    </div>
                                    <h5>Upload or Drop file here.</h5>
                                  </div>
                                </Label>
                                <Input
                                  className="form-control d-none"
                                  id="front-cnic"
                                  type="file"
                                  accept="image/png, image/gif, image/jpeg"
                                  onChange={handleFrontCnicImageChange}
                                />
                              </>
                            )}
                          </div>

                          {/* Display Image if Selected */}
                          {formik.values.cnicFrontImage && (
                            <div className="p-2 ">
                              <Row className="align-items-center">
                                <Col className="col-auto">
                                  <img
                                    height="100"
                                    style={{ width: "200px ", height: "200px" }}
                                    className="avatar-sm rounded bg-light position-relative"
                                    src={formik.values.cnicFrontImage}
                                    alt="Selected document"
                                    onClick={() =>
                                      openViewer(formik?.values?.cnicFrontImage)
                                    }
                                  />
                                  <ImageViewer
                                    isOpen={isViewerOpen}
                                    imageUrl={currentImage}
                                    toggle={closeViewer}
                                  />
                                  <i
                                    className="bx bx-trash bg-red text-white rounded bg-danger p-1 position-absolute  cursor-pointer"
                                    onClick={handleDeleteFrontCnicImage}
                                    style={{
                                      top: "5px",
                                      right: "18px",
                                      width: "20px",
                                    }}
                                  ></i>
                                </Col>
                                {/* <Col>
                                <p className="mb-0">
                                  <strong>{formik.values.cnicBackImage.metadata.name}</strong>
                                </p>
                              </Col> */}
                              </Row>
                            </div>
                          )}
                        </Col>

                        {/* Additional content */}
                        <Col sm={12} md={4} lg={4} xxl={4}>
                          <h5 className="fw-bold text-success">
                            You may follow these sample type(s). Full list
                            below.
                          </h5>
                          <figure className="flex justify-center items-center">
                            <img
                              src={Nic}
                              alt="Email Communication"
                              style={{ width: "200px ", height: "200px" }}
                              className=" object-contain"
                            />
                          </figure>
                        </Col>

                        <Col sm={12} md={4} lg={4} xxl={4}>
                          <h6 className="text-black-50">
                            Please prepare a clear ID with{" "}
                            <span className="fw-bolder opacity-25">
                              First and Last Name, Birth Date, and Expiration
                              Date
                            </span>{" "}
                            visible.
                          </h6>
                          <p className="text-black-50 mt-4">
                            Size between 330x330 and 5000x5000 px, and image
                            size below 10M. Please do upload the photo with
                            similar to the example.
                          </p>
                        </Col>
                      </Row>

                      <div className="my-3">
                        <h6 className="fw-bold">
                          <span className="text-danger">*</span> ID Back Side
                        </h6>
                      </div>

                      <Row
                        style={{ background: "#f8f9fd" }}
                        className="rounded-3 p-3 mx-1"
                      >
                        <Col sm={12} md={4} lg={4} xxl={4}>
                          <h5 className="fw-bolder">Upload NIC Back Image</h5>
                          {/* Image Upload Section */}
                          <div
                            className={`dropzone dz-clickable ${
                              formik.values.cnicBackImage ? "d-none" : ""
                            }`}
                          >
                            {!formik.values.cnicBackImage && (
                              <>
                                <Label
                                  htmlFor="back-cnic"
                                  className="mb-0 d-flex"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="right"
                                  title="Select Image"
                                >
                                  <div className="dz-message needsclick">
                                    <div className="mb-3 mt-5">
                                      <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                                    </div>
                                    <h5>Upload or Drop file here.</h5>
                                  </div>
                                </Label>
                                <Input
                                  className="form-control d-none"
                                  id="back-cnic"
                                  type="file"
                                  accept="image/png, image/gif, image/jpeg"
                                  onChange={handleBackCnicImageChange}
                                />
                              </>
                            )}
                          </div>

                          {/* Display Image if Selected */}
                          {formik.values.cnicBackImage && (
                            <div className="p-2">
                              <Row className="align-items-center">
                                <Col className="col-auto">
                                  <img
                                    height="100"
                                    className="avatar-sm rounded bg-light position-relative"
                                    style={{ width: "200px ", height: "200px" }}
                                    src={formik.values.cnicBackImage}
                                    alt="Selected document"
                                    onClick={() =>
                                      openViewer(formik.values.cnicBackImage)
                                    }
                                  />
                                  <ImageViewer
                                    isOpen={isViewerOpen}
                                    imageUrl={currentImage}
                                    toggle={closeViewer}
                                  />
                                  <i
                                    className="bx bx-trash bg-red text-white rounded bg-danger p-1 cursor-pointer position-absolute "
                                    onClick={handleDeleteBackCnicImage}
                                    style={{
                                      top: "5px",
                                      right: "18px",
                                      width: "20px",
                                    }}
                                  ></i>
                                </Col>
                                {/* <Col>
                                <p className="mb-0">
                                  <strong>{formik.values.cnicBackImage.metadata.name}</strong>
                                </p>
                              </Col> */}
                              </Row>
                            </div>
                          )}
                        </Col>

                        {/* Additional content */}
                        <Col sm={12} md={4} lg={4} xxl={4}>
                          <h5 className="fw-bold text-success">
                            You may follow these sample type(s). Full list
                            below.
                          </h5>
                          <figure className="flex justify-center items-center">
                            <img
                              src={Nic}
                              alt="Email Communication"
                              style={{ width: "200px ", height: "200px" }}
                              className="w-20 h-20 object-contain"
                            />
                          </figure>
                        </Col>
                        <Col sm={12} md={4} lg={4} xxl={4}>
                          ID Document Upload
                          <p className="text-black-50 mt-4">
                            Size between 330x330 and 5000x5000 px, and image
                            size below 10M. Please do upload the photo with
                            similar to the example.
                          </p>
                        </Col>

                        <Col sm={12} md={4} lg={4} xxl={4}>
                          <h6 className="text-black-50">
                            Please prepare a clear ID with{" "}
                            <span className="fw-bolder opacity-25">
                              First and Last Name, Birth Date, and Expiration
                              Date
                            </span>{" "}
                            visible.
                          </h6>
                        </Col>
                      </Row>

                      <h3 className="fw-bold my-2">Verify ID Information</h3>
                      <Col xxl={6} md={12} sm={12} lg={12} className="mt-3">
                        <Label htmlFor="addressDetails" className="form-label">
                          <span className="text-danger me-1"> *</span>Name on
                          ID(Need be exactly the same)
                          <span>
                            <i className="ri-information-line ms-2 fs-5 fw-normal"></i>
                          </span>
                        </Label>
                        <Input
                          type="text"
                          name="cnicName"
                          className={`form-control ${
                            formik.touched.cnicName && formik.errors.cnicName
                              ? "is-invalid"
                              : ""
                          }`}
                          id="cnicName"
                          placeholder="Cnic Name"
                          onChange={(e) => {
                            formik.handleChange(e);
                            handleFieldChange("cnicName", e);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.cnicName}
                        />
                        {formik.touched.cnicName && formik.errors.cnicName && (
                          <div className="invalid-feedback">
                            {formik.errors.cnicName}
                          </div>
                        )}
                      </Col>
                      <Col xxl={6} md={12} sm={12} lg={12} className="mt-3">
                        <Label htmlFor="addressDetails" className="form-label">
                          <span className="text-danger me-1"> *</span>Identity
                          Card No.
                          <span>
                            <i className="ri-information-line ms-2 fs-5 fw-normal"></i>
                          </span>
                        </Label>
                        <Input
                          type="text"
                          name="cnicNumber"
                          className={`form-control ${
                            formik.touched.cnicNumber &&
                            formik.errors.cnicNumber
                              ? "is-invalid"
                              : ""
                          }`}
                          id="cnicNumber"
                          placeholder="Cnic Number"
                          onChange={(e) => {
                            formik.handleChange(e);
                            handleFieldChange("cnicNumber", e);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.cnicNumber}
                        />
                        {formik.touched.cnicNumber &&
                          formik.errors.cnicNumber && (
                            <div className="invalid-feedback">
                              {formik.errors.cnicNumber}
                            </div>
                          )}
                      </Col>
                    </CardBody>
                  </Card>
                )}

                <Card>
                  <CardBody>
                    <h3 className=" fw-bolder mb-2">Upload Bank Document</h3>
                    <h5>Upload Bank Document</h5>
                    {/* <h6 className="text-black-50">Size between 330x330 and 5000x5000 px, and image size below 10m.Please do upload the photo with the example</h6> */}
                    <Row
                      style={{ background: "#f8f9fd" }}
                      className="rounded-3 p-3 mx-1 my-2 "
                    >
                      <Col sm={12} md={4} lg={4} xxl={4}>
                        <h5 className="fw-bolder">Upload Cheque Book Image</h5>
                        <div
                          className={`dropzone dz-clickable ${
                            formik.values.bankDocuments ? "d-none" : ""
                          }`}
                        >
                          {!formik.values.bankDocuments && (
                            <>
                              {formik.values.bankDocuments && <Loader />}
                              <Label
                                htmlFor="customer-image-bank-input"
                                className="mb-0 d-flex"
                                data-bs-toggle="tooltip"
                                data-bs-placement="right"
                                title="Select Image"
                              >
                                {!formik.values.bankDocuments && (
                                  <div className="dz-message needsclick">
                                    <div className="mb-3 mt-5">
                                      <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                                    </div>
                                    <h5>Upload or Drop file here.</h5>
                                  </div>
                                )}
                              </Label>
                              <Input
                                className="form-control d-none"
                                id="customer-image-bank-input"
                                type="file"
                                accept="image/png, image/gif, image/jpeg"
                                onChange={handleBankImageChange}
                              />
                            </>
                          )}
                        </div>
                        {formik.values.bankDocuments && (
                          <div className="p-2">
                            <Row className="align-items-center">
                              <Col className="col-auto">
                                <img
                                  data-dz-thumbnail=""
                                  height="100"
                                  className="avatar-sm rounded bg-light position-relative"
                                  style={{ width: "200px ", height: "200px" }}
                                  src={formik.values.bankDocuments}
                                  onClick={() =>
                                    openViewer(formik.values.bankDocuments)
                                  }
                                />
                                <ImageViewer
                                  isOpen={isViewerOpen}
                                  imageUrl={currentImage}
                                  toggle={closeViewer}
                                />
                                <i
                                  className="bx bx-trash bg-red text-white rounded bg-danger p-1 cursor-pointer position-absolute"
                                  onClick={handleDeleteImageBank}
                                  style={{
                                    top: "5px",
                                    right: "18px",
                                    width: "20px",
                                  }}
                                ></i>
                              </Col>
                              {/* <Col>
                              <p className="mb-0">
                                <strong>{selectedImageBank.metadata && selectedImageBank.metadata.name}</strong>
                              </p>
                            </Col> */}

                              <Col></Col>
                            </Row>
                          </div>
                        )}
                      </Col>

                      <Col sm={12} md={4} lg={4} xxl={4}>
                        <h5 className="fw-bold text-success">
                          You may follow these sample type(s). Full list below.
                        </h5>
                        <figure className="flex justify-center items-center">
                          <img
                            src={check}
                            alt="Email Communication"
                            style={{ width: "200px", height: "200px" }}
                            className="w-20 h-20 object-contain"
                          />
                        </figure>
                      </Col>

                      <Col sm={12} md={4} lg={4} xxl={4}>
                        <h6 className="text-black-50">
                          Please prepare a clear ID with{" "}
                          <span className="fw-bolder opcity-25">
                            First and Last Name, Birth Date and Expiration date
                          </span>{" "}
                          to be seen, with no object covering.
                          <p className="text-black-50 mt-4">
                            Size between 330x330 and 5000x5000 px, and image
                            size below 10M. Please do upload the photo with
                            similar to the example.
                          </p>
                        </h6>
                      </Col>
                    </Row>

                    <div className="form">
                      <h3 className=" fw-bold mb-3">Verify Bank Information</h3>
                      <Col xxl={6} md={12} sm={12} lg={12}>
                        <Label htmlFor="addressDetails" className="form-label">
                          <span className="text-danger me-1"> *</span>Account
                          Name
                        </Label>
                        <Input
                          type="text"
                          name="addressDetails"
                          className={`form-control ${
                            formik.touched.accountName &&
                            formik.errors.accountName
                              ? "is-invalid"
                              : ""
                          }`}
                          id="accountName"
                          placeholder="First And last Name"
                          onChange={(e) => {
                            formik.handleChange(e);
                            handleFieldChange("accountName", e);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.accountName}
                        />
                        {formik.touched.accountName &&
                          formik.errors.accountName && (
                            <div className="invalid-feedback">
                              {formik.errors.accountName}
                            </div>
                          )}
                      </Col>
                      <Col xxl={6} md={12} sm={12} lg={12} className="mt-3">
                        <Label htmlFor="addressDetails" className="form-label">
                          <span className="text-danger me-1"> *</span>Account
                          Number
                        </Label>
                        <Input
                          type="text"
                          name="accountNumber"
                          className={`form-control ${
                            formik.touched.accountNumber &&
                            formik.errors.accountNumber
                              ? "is-invalid"
                              : ""
                          }`}
                          id="accountNumber"
                          placeholder="Bank Account Number"
                          onChange={(e) => {
                            formik.handleChange(e);
                            handleFieldChange("accountNumber", e);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.accountNumber}
                        />
                        {formik.touched.accountNumber &&
                          formik.errors.accountNumber && (
                            <div className="invalid-feedback">
                              {formik.errors.accountNumber}
                            </div>
                          )}
                      </Col>
                      <Col xxl={6} md={12} sm={12} lg={12} className="mt-3">
                        <Label htmlFor="Iban" className="form-label">
                          <span className="text-danger me-1"> *</span>IBAN
                        </Label>
                        <Input
                          type="text"
                          name="Iban"
                          className={`form-control ${
                            formik.touched.Iban && formik.errors.Iban
                              ? "is-invalid"
                              : ""
                          }`}
                          id="Iban"
                          placeholder="IBAN"
                          onChange={(e) => {
                            formik.handleChange(e);
                            handleFieldChange("Iban", e);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.Iban}
                        />
                        {formik.touched.Iban && formik.errors.Iban && (
                          <div className="invalid-feedback">
                            {formik.errors.Iban}
                          </div>
                        )}
                      </Col>
                      <Col xxl={6} md={12} sm={12} lg={12}>
                        <Label htmlFor="bank" className="form-label mt-3">
                          <span className="text-danger me-1"> *</span>Bank
                        </Label>
                        <select
                          className={`form-select mb-3 ${
                            formik.touched.bank && formik.errors.bank
                              ? "is-invalid"
                              : ""
                          }`}
                          name="bank"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.bank}
                        >
                          <option value="">Select Bank</option>
                          {loading && <option>Loading...</option>}
                          {!loading &&
                            banks.map((bank: any) => (
                              <option
                                key={bank._id}
                                value={bank.value || bank.id}
                              >
                                {bank.label || bank.name}
                              </option>
                            ))}
                        </select>
                        {formik.touched.bank && formik.errors.bank && (
                          <div className="invalid-feedback">
                            {formik.errors.bank}
                          </div>
                        )}
                      </Col>
                      <Col xxl={6} md={12} sm={12} lg={12} className="mt-3">
                        <Label htmlFor="bankCode" className="form-label">
                          <span className="text-danger me-1"> *</span>Bank Code
                        </Label>
                        <Input
                          type="text"
                          name="bankCode"
                          className={`form-control ${
                            formik.touched.bankCode && formik.errors.bankCode
                              ? "is-invalid"
                              : ""
                          }`}
                          id="bankCode"
                          placeholder="Bank Code"
                          onChange={(e) => {
                            formik.handleChange(e);
                            handleFieldChange("bankCode", e);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.bankCode}
                        />
                        {formik.touched.bankCode && formik.errors.bankCode && (
                          <div className="invalid-feedback">
                            {formik.errors.bankCode}
                          </div>
                        )}
                      </Col>
                      <Col xxl={6} md={12} sm={12} lg={12} className="mt-3">
                        <Label htmlFor="bankBranch" className="form-label">
                          <span className="text-danger me-1"> *</span>Bank
                          Branch
                        </Label>
                        <Input
                          type="text"
                          name="bankBranch"
                          className={`form-control ${
                            formik.touched.bankBranch &&
                            formik.errors.bankBranch
                              ? "is-invalid"
                              : ""
                          }`}
                          id="bankBranch"
                          placeholder="Bank Branch"
                          onChange={(e) => {
                            formik.handleChange(e);
                            handleFieldChange("bankBranch", e);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.bankBranch}
                        />
                        {formik.touched.bankBranch &&
                          formik.errors.bankBranch && (
                            <div className="invalid-feedback">
                              {formik.errors.bankBranch}
                            </div>
                          )}
                      </Col>
                    </div>
                  </CardBody>
                </Card>
                <div>
                  <Card>
                    <CardBody>
                      {<h5 className="fw-bolder mb-3">Business Address</h5>}
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={formik.values.isBusinessAddressSame}
                          onChange={handleToggle}
                        />
                        <p>Same as Shop Address</p>
                      </div>
                      {!formik.values.isBusinessAddressSame && (
                        <AddressFormBox
                          addressObject={
                            seller &&
                            seller.idBankDetails &&
                            seller.idBankDetails.businessAddress
                              ? seller.idBankDetails.businessAddress
                              : undefined
                          }
                          onAddressUpdate={(address) =>
                            onBusinessAddressChange(address)
                          }
                          key="1"
                        />
                      )}
                    </CardBody>
                  </Card>
                </div>

                <Card>
                  <CardBody>
                    <div className="d-flex justify-content-end">
                      <Button type="submit" color="success" className="ml-auto">
                        Submit
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Form>
            </Col>

            <Col xl={3}>
              <div className="card ">
                <div className="card-body d-grid ">
                  <div className="form-check form-check-inline mb-3">
                    <Input
                      className="form-check-input"
                      type="radio"
                      name="sellerType"
                      id="faqsOne"
                      value="faqsOne"
                      onChange={handleFaqsTypeChange}
                      checked={faqsType === "faqsOne"}
                    />
                    <Label className="form-check-label" htmlFor="faqsOne">
                      Upload ID Document
                    </Label>
                  </div>

                  <div className="form-check form-check-inline">
                    <Input
                      className="form-check-input"
                      type="radio"
                      name="sellerType"
                      id="faqsTow"
                      value="faqsTow"
                      onChange={handleFaqsTypeChange}
                      checked={faqsType === "faqsTow"}
                    />
                    <Label className="form-check-label" htmlFor="faqsTow">
                      Upload Bank Document
                    </Label>
                  </div>
                </div>
              </div>

              <div className="card bg-success bg-opacity-25 simplebar-content">
                <div className="card-body ">
                  <h3 className="text-danger p-0 m-0">FAQ</h3>
                  <SimpleBar style={{ height: "45vh" }} className="px-3">
                    {faqsType === "faqsOne" && (
                      <>
                        <div className="my-2">
                          <h5 className="mb-1">
                            1. If my ID is blurred/unclear, can I get approved?
                          </h5>
                          <p className="text-black-50">
                            We need a clear information and full visibility of
                            your ID without any object covering it. If your ID
                            is unclear, please reach help by clicking the icon
                            of the right bar here.
                          </p>
                        </div>
                        <div className="my-2">
                          <h5 className="mb-1">
                            2. Is it necessary that the information has to be
                            exactly the same as the photo uploaded?
                          </h5>
                          <p className="text-black-50">
                            Yes, the information that you input it must match
                            with the upload photo in order to get verified.
                          </p>
                        </div>
                        <div className="my-2">
                          <h5 className="mb-1">
                            3. Does the name on ID card and bank account have to
                            be the same person?
                          </h5>
                          <p className="text-black-50">
                            Yes, name on the ID card has to be the same as the
                            bank account name.
                          </p>
                        </div>
                      </>
                    )}

                    {faqsType === "faqsTow" && (
                      <div className="my-2">
                        <h5 className="mb-1">
                          1. If my ID is Blurred/unclear, can i get approved
                        </h5>
                        <p className="text-black-50">
                          Lorem ipsum dolor sit, amet consectetur adipisicing
                          elit. Illum dolorum facere, sed vel autem provident
                          reprehenderit assumenda expedita dignissimos nam,
                          consectetur iusto soluta!
                        </p>
                      </div>
                    )}
                  </SimpleBar>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    )
  );
};

export default withRouter(BankInformation);
